<div class="row">
    <div class="col-12">
        Descrição: {{descricao}}
    </div>
</div>